import { ComponentStyles } from "types/common";

export const commentStyles: ComponentStyles = {
  commentActionIconButton: {
    // width: '.5rem',
    // aspectRatio: '1 / 1',
    // display: 'none',
  },
}
